import(/* webpackMode: "eager" */ "/app/node_modules/@akinon/next/utils/get-currency.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/widgets/blog/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/widgets/blog/recent-slider.tsx");
